export const DEFAULT_CREDIT_PROVIDER_DATA = {
  providerType: "",
  provider: "",
  balanceOutstanding: "",
  settlementAmount: "",
  monthlyPayment: "",
  consolidate: null,
  isPartConsolidated: null,
};

const DEFAULT_EXPENDITURE_DATA = {
  householdExpenditure: {
    futureChangeInExpenditure: undefined,
    changeInExpenditureDetail: "",
    foodDrinkGroceries: undefined,
    clothingFootwearPersonal: undefined,
    utilitiesOtherHousing: undefined,
    furnishingsHouseholdMaintenance: undefined,
    transportTravel: undefined,
    communication: undefined,
    recreationRestaurantsHotels: undefined,
    insurance: undefined,
    councilTax: undefined,
    cigarettesTobacco: undefined,
    childcareSchoolFees: undefined,
    adultCare: undefined,
    maintenanceCsa: undefined,
    mortgageEndowment: undefined,
    health: undefined,
    other: undefined,
  },
  applicantCredit: [
    {
      applicantHasOutstandingCredit: undefined,
      creditProviders: [],
    },
  ],
};

const DEFAULT_FORM_DATA = {
  expenditure: {
    ...DEFAULT_EXPENDITURE_DATA,
  },
};

export default DEFAULT_FORM_DATA;
